<p>automatic-routines-list-tablet works!</p>
